import $ from "jquery";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "jquery-countdown";
import "bootstrap";
import "bootstrap-datepicker";
import "slick-carousel";
import "d3";

import { frontend } from "widgets-module/app";

window.$ = window.jQuery = $;

$(() => frontend.init());
